<template>
  <div>
    <el-col :span="24">
      <div
        v-loading="!!pendingByReport.client_total"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Client Total</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.client_total.updated_at }}
          </span>
        </div>
        <clientTotal :tableData="tableDataProp.client_total?.data || []" ref="grandchildComp" />
      </div>

      <div
        v-loading="!!pendingByReport.full_breakdown"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Full Breakdown</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.full_breakdown.updated_at }}
          </span>
        </div>
        <fullBreakdown :tableData="tableDataProp.full_breakdown?.data || []" ref="grandchildComp2" />
      </div>

      <div
        v-loading="!!pendingByReport.by_state_and_region"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">State and Region</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.by_state_and_region.updated_at }}
          </span>
        </div>
        <byStateAndRegion :tableData="tableDataProp.by_state_and_region?.data || []" ref="grandchildComp3" />
      </div>

      <div
        v-loading="!!pendingByReport.by_state_and_region_and_charger_type"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">State Region and Charger Type</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.by_state_and_region_and_charger_type.updated_at }}
          </span>
        </div>
        <StateRegionAndChargerType
        :tableData="tableDataProp.by_state_and_region_and_charger_type?.data || []" ref="grandchildComp4" />
      </div>


      <div
        v-loading="!!pendingByReport.private_fleet_by_site"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Private Fleet By Site</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.private_fleet_by_site.updated_at }}
          </span>
        </div>
        <PrivateFleetBySite :tableData="tableDataProp.private_fleet_by_site?.data || []" ref="grandchildComp8" />
      </div>

      <div
        v-loading="!!pendingByReport.by_state_and_region_1"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">State and Region 1</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.by_state_and_region_1.updated_at }}
          </span>
        </div>
        <StateRegionOne :tableData="tableDataProp.by_state_and_region_1?.data || []" ref="grandchildComp6" />
      </div>

      <div
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">State and Region 2</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.by_state_and_region_2.updated_at }}
          </span>
        </div>
        <StateRegionTwo :tableData="tableDataProp.by_state_and_region_2?.data || []" ref="grandchildComp7" />
      </div>

      <div
        v-loading="!!pendingByReport.sd_vista"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">SD Vista</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.sd_vista.updated_at }}
          </span>
        </div>
        <SdVista :tableData="tableDataProp.sd_vista?.data || []" ref="grandchildComp9" />
      </div>

      <div
        v-loading="!!pendingByReport.project_region_renewable_report"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Project Region Renewable</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ tableDataProp.project_region_renewable_report.updated_at }}
          </span>
        </div>
        <RenewableProjectRegion
          :tableData="tableDataProp.project_region_renewable_report?.data || []"
          ref="grandchildComp10"
        />
      </div>
    </el-col>
  </div>
</template>

<script>
import clientTotal from "./clientTotal.vue";
import byStateAndRegion from "./byStateAndRegion.vue";
import fullBreakdown from "./fullBreakdown.vue";
import StateRegionAndChargerType from "./StateRegionAndChargerType.vue";
import StateRegionOne from "./StateRegionOne.vue";
import StateRegionTwo from "./StateRegionTwo.vue";
import PrivateFleetBySite from "./PrivateFleetBySite.vue";
import SdVista from "./SdVista.vue";
import RenewableProjectRegion from "./RenewableProjectRegion.vue";

export default {
  props: {
    parentDataFilter: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    tableDataProp: {
      type: Object,
      required: true,
      default: () => (
        {
          client_total: [],
          full_breakdown: [],
          by_state_and_region: [],
          by_state_and_region_and_charger_type: [],
          private_fleet_by_site: [],
          by_state_and_region_1: [],
          by_state_and_region_2: [],
          sd_vista: [],
          project_region_renewable_report: [],
        }
      ),
    },
    pendingByReport: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    clientTotal,
    byStateAndRegion,
    fullBreakdown,
    StateRegionAndChargerType,
    StateRegionOne,
    StateRegionTwo,
    PrivateFleetBySite,
    SdVista,
    RenewableProjectRegion,
  },
};
</script>